import { render, staticRenderFns } from "./tipSummary.vue?vue&type=template&id=71c5da37&"
import script from "./tipSummary.vue?vue&type=script&lang=js&"
export * from "./tipSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports